<template>
  <Popup :ref="(el) => popup = el"
         class="popup__lg"
         :title="popupTitle"
         @onClose="hide"
  >
    <form class="requisites">
      <div class="requisites__container" v-if="templateMode">
        <div class="requisites__block">
          <div class="requisites__label requisites__label--start text-capitalize-first">
            {{ $t("requisites.templates.name") }}
          </div>
          <div class="requisites__content">
            <FormInputWrapper v-slot="parentProps" field="name" form="requisitesForm">
              <input v-model="templateName" :class="parentProps.class" type="text" maxlength="255" class="form-control" id="templateName">
            </FormInputWrapper>
          </div>
        </div>
      </div>
      <div class="requisites__container" v-if="templateSelectVisible">
        <div class="requisites__block">
          <div class="requisites__label requisites__label--start text-capitalize-first">
            {{ $t("requisites.templates.select_label") }}
          </div>
          <div class="requisites__content">
            <Multiselect id="requisiteTemplate"
                         v-model="selectedTemplate"
                         :options="templates"
                         label="name"
                         track-by="id"
                         :multiple="false"
                         select-label="Select"
                         :placeholder="$t('requisites.templates.select_placeholder')"
                         @select="applyTemplate"
                         @remove="clearTemplate"
            >
            </Multiselect>
          </div>
        </div>
      </div>
      <div class="requisites__container">
        <div class="requisites__block requisites__block--switcher">
          <div class="requisites__label text-capitalize-first">{{ form.isActive ? $t('requisites.active') : $t('requisites.inactive') }}</div>
          <div class="requisites__content requisites__content__switch">
            <label class="switch">
              <input type="checkbox" v-model="form.isActive">
              <span class="slider"></span>
            </label>
          </div>
        </div>
      </div>
      <div class="requisites__container">

        <div class="requisites__block">
          <div class="requisites__label requisites__label--start text-capitalize-first">
            {{ $t("labels.currency") }}
          </div>
          <div class="requisites__content">
            <FormInputWrapper v-slot="parentProps" field="currency" form="requisitesForm">
              <Multiselect id="currency"
                           class=""
                           v-model="form.currency"
                           :options="store.getters['currencyMethods/currencies']"
                           :custom-label="(opt) => `${opt}`"
                           :multiple="false"
                           :class="parentProps.class"
                           select-label="Select"
                           placeholder=""
              >
              </Multiselect>
            </FormInputWrapper>
          </div>
        </div>

        <div class="requisites__block">
          <div class="requisites__label requisites__label--start text-capitalize-first">
            {{ $t("labels.payment_option") }}
          </div>
          <div class="requisites__content">
            <FormInputWrapper v-slot="parentProps" field="paymentOption" form="requisitesForm">
              <Multiselect id="paymentOption"
                           :disabled="!form.currency"
                           class=""
                           v-model="form.paymentOption"
                           :options="store.getters['currencyMethods/options'](form.currency)"
                           :custom-label="(opt) => helper.trans(`payment_options.${opt}`)"
                           :multiple="false"
                           :class="parentProps.class"
                           select-label="Select"
                           placeholder=""
              >
              </Multiselect>
            </FormInputWrapper>
          </div>
        </div>

        <div class="requisites__block" v-if="[PaymentOption.CROSS_BORDER, PaymentOption.MOBILE_TOP_UP, PaymentOption.SBP_QR, PaymentOption.CARD_ACQUIRING_REDIRECT].includes(form.paymentOption)">
          <div class="requisites__label requisites__label--start text-capitalize-first">
            {{ $t("labels.crossBorderCurrency") }}
          </div>
          <div class="requisites__content">
            <FormInputWrapper v-slot="parentProps" field="crossBorderCurrency" form="requisitesForm">
              <Multiselect id="currency"
                           class=""
                           v-model="form.crossBorderCurrency"
                           :options="store.getters['currencyMethods/crossBorderCurrencies']"
                           :custom-label="(opt) => `${opt}`"
                           :multiple="false"
                           :class="parentProps.class"
                           select-label="Select"
                           placeholder=""
              >
              </Multiselect>
            </FormInputWrapper>
          </div>
        </div>

        <div class="requisites__container" v-if="isVietQr">
          <div class="requisites__block" v-if="!templateMode">
            <div class="requisites__label requisites__label--start text-capitalize-first">
              {{ $t("labels.viet_qr_input_mode") }}
            </div>
            <div class="requisites__content">
              <div class="radio-list">
                <div class="radio">
                  <input v-model="vietQrInputMode" value="auto" type="radio" name="vietQrInputMode" id="vietQrModeAuto">
                  <label for="vietQrModeAuto">{{ $t('labels.viet_qr_mode_auto') }}</label>
                </div>
                <div class="radio">
                  <input v-model="vietQrInputMode" value="upload" type="radio" name="vietQrInputMode" id="vietQrModeUpload">
                  <label for="vietQrModeUpload">{{ $t('labels.viet_qr_mode_upload') }}</label>
                </div>
              </div>
            </div>
          </div>

          <div class="requisites__block">
            <div class="requisites__label requisites__label--start text-capitalize-first">
              {{ $t("labels.viet_qr_type") }}
            </div>
            <div class="requisites__content">
              <div class="radio-list">
                <div class="radio">
                  <input v-model="form.vietQrIsStatic" :value="false" type="radio" name="vietQrIsStatic" id="vietQrDynamic">
                  <label for="vietQrDynamic">{{ $t('labels.viet_qr_dynamic') }}</label>
                </div>
                <div class="radio">
                  <input v-model="form.vietQrIsStatic" :value="true" type="radio" name="vietQrIsStatic" id="vietQrStatic">
                  <label for="vietQrStatic">{{ $t('labels.viet_qr_static') }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="requisites__container" v-if="isIndQr">
          <div class="requisites__block">
            <div class="requisites__label requisites__label--start text-capitalize-first">
              {{ $t("labels.qris_type") }}
            </div>
            <div class="requisites__content">
              <div class="radio-list">
                <div class="radio">
                  <input v-model="form.qrisIsStatic" :value="false" type="radio" name="qrisIsStatic" id="qrisDynamic">
                  <label for="qrisDynamic">{{ $t('labels.qris_dynamic') }}</label>
                </div>
                <div class="radio">
                  <input v-model="form.qrisIsStatic" :value="true" type="radio" name="qrisIsStatic" id="qrisStatic">
                  <label for="qrisStatic">{{ $t('labels.qris_static') }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="requisites__container" v-if="isBrQr">
          <div class="requisites__block">
            <div class="requisites__label requisites__label--start text-capitalize-first">
              {{ $t("labels.pix_type") }}
            </div>
            <div class="requisites__content">
              <div class="radio-list">
                <div class="radio">
                  <input :checked="form.pixIsStatic !== true" type="radio" name="pixIsStatic" id="pixDynamic" @change="form.pixIsStatic = false">
                  <label for="pixDynamic">{{ $t('labels.pix_dynamic') }}</label>
                </div>
                <div class="radio">
                  <input :checked="form.pixIsStatic === true" type="radio" name="pixIsStatic" id="pixStatic" @change="form.pixIsStatic = true">
                  <label for="pixStatic">{{ $t('labels.pix_static') }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="requisites__block">
          <div class="requisites__label requisites__label--start  text-capitalize-first">
          </div>
          <div class="requisites__content">
            <FormInputWrapper v-slot="parentProps" field="method" form="requisitesForm">
              <Multiselect id="method"
                           :disabled="!form.paymentOption || !paymentOptionCurrency"
                           class=""
                           v-model="form.method"
                           :options="methodOptions"
                           :custom-label="(opt) => helper.trans(`pay_methods.${opt}`)"
                           :multiple="false"
                           :class="parentProps.class"
                           select-label="Select"
                           placeholder=""
              >
                <template #option="props">
                  <div class="pay-method">
                    <PayMethodIcon icon-class="icon" :method="props.option"></PayMethodIcon>
                    <span>{{ helper.trans('pay_methods.' + props.option) }}</span>
                  </div>
                </template>

                <template #singleLabel="props">
                  <div class="pay-method">
                    <PayMethodIcon icon-class="icon" :method="props.option"></PayMethodIcon>
                    <span>{{ helper.trans('pay_methods.' + props.option) }}</span>
                  </div>
                </template>

              </Multiselect>
            </FormInputWrapper>
          </div>
        </div>

        <div class="requisites__block" v-if="form.currency && form.paymentOption && form.method && store.getters['currencyMethods/paymentSystems'](form.currency, form.paymentOption).length > 0">
          <div class="requisites__label requisites__label--start text-capitalize-first">
            {{ $t("labels.payment_system") }}
          </div>
          <div class="requisites__content">
            <FormInputWrapper v-slot="parentProps" field="paymentSystem" form="paymentSystem">
              <Multiselect id="paymentSystem"
                           class=""
                           v-model="form.paymentSystem"
                           :options="store.getters['currencyMethods/paymentSystems'](form.currency, form.paymentOption)"
                           :custom-label="(opt) => helper.trans(`payment_systems.${opt}`)"
                           :multiple="false"
                           :class="parentProps.class"
                           select-label="Select"
                           placeholder=""
              >
              </Multiselect>
            </FormInputWrapper>
          </div>
        </div>

        <div class="requisites__block" v-if="!templateMode && form.paymentOption !== PaymentOption.VIET_QR && form.paymentOption !== PaymentOption.IND_QR && form.paymentOption !== PaymentOption.BR_QR && form.paymentOption !== PaymentOption.MANUAL_SBP_QR">
          <div class="requisites__label requisites__label--start text-capitalize-first">
            {{ requisiteFieldLabel }}
          </div>
          <div class="requisites__content">
            <FormInputWrapper v-slot="parentProps" field="requisites" form="requisitesForm">
              <input v-model="form.requisites"
                     v-maska
                     :placeholder="requisitesMaskaPlaceholder"
                     :class="parentProps.class"
                     :data-maska="requisitesMaskaOptions.pattern"
                     :data-maska-tokens="requisitesMaskaOptions.tokens"
                     type="text" class="form-control " id="requisites">
            </FormInputWrapper>
          </div>
        </div>

        <div class="requisites__block" v-if="!templateMode && form.paymentOption === PaymentOption.SBP_QR && form.method === PaymentMethod.qr_manager">
          <div class="requisites__label"></div>
          <div class="requisites__content">
            <small class="text-muted">{{ $t('qr_manager.requisites_hint') }}</small>
          </div>
        </div>

        <div class="requisites__block" v-if="isHolderNameVisible">
          <div class="requisites__label requisites__label--start text-capitalize-first">
            {{ $t("labels.holder_name") }}
            <small v-if="isIndQr || isBrQr" class="text-muted fw-normal">({{ $t('labels.optional_field') }})</small>
          </div>
          <div class="requisites__content">
            <FormInputWrapper v-slot="parentProps" field="holderName" form="requisitesForm">
              <input v-model="form.holderName" :class="parentProps.class" type="text" class="form-control " id="holderName">
            </FormInputWrapper>
          </div>
        </div>

        <div class="requisites__block" v-if="form.paymentOption === PaymentOption.CROSS_BORDER">
          <div class="requisites__label requisites__label--start text-capitalize-first">
            {{ $t("labels.raw_field.swift") }}
            <small class="text-muted fw-normal">({{ $t('labels.optional_field') }})</small>
          </div>
          <div class="requisites__content">
            <FormInputWrapper v-slot="parentProps" field="raw.swift" form="requisitesForm">
              <input v-model="form.raw.swift" :class="parentProps.class" type="text" class="form-control " id="crossBorderSwift">
            </FormInputWrapper>
          </div>
        </div>

        <div class="requisites__block" v-if="isAccountNumberVisible">
          <div class="requisites__label requisites__label--start text-capitalize-first">
            {{ $t("labels.account_number") }}
          </div>
          <div class="requisites__content">
            <FormInputWrapper v-slot="parentProps" field="accountNumber" form="requisitesForm">
              <input v-model="form.accountNumber"
                     v-maska
                     :class="parentProps.class"
                     :data-maska="isVietQrAutoMode ? '9' : null"
                     :data-maska-tokens="isVietQrAutoMode ? '9:[0-9]:repeated' : null"
                     type="text"
                     class="form-control"
                     id="accountNumber">
            </FormInputWrapper>
          </div>
        </div>

      </div>

      <div class="requisites__container" v-if="form.paymentOption === PaymentOption.SBP_QR && form.method === PaymentMethod.qr_manager && additionalFields.length > 0">
        <div class="requisites__block">
          <div class="requisites__label"></div>
          <div class="requisites__content">
            <small class="text-muted">{{ $t('qr_manager.p2c_credentials_intro') }}</small>
          </div>
        </div>
      </div>

      <div class="requisites__container" v-if="additionalFields.length > 0">
        <div class="requisites__block" v-for="field in additionalFields">
          <div class="requisites__label requisites__label--start text-capitalize-first">
            {{ $t(`labels.additional_field.${field.name}`) }}
          </div>
          <div class="requisites__content">
            <FormInputWrapper v-slot="parentProps" :field="`additional_field_${field.name}`" form="requisitesForm">

              <input v-if="field.type === 'input'" v-model="form.p2cConfig[field.name]" :class="parentProps.class" type="text" class="form-control" :id="`additional_field_${field.name}`">
              <textarea rows="5" v-if="field.type === 'textarea'" v-model="form.p2cConfig[field.name]" :class="parentProps.class" type="text" class="form-control" :id="`additional_field_${field.name}`"></textarea>
              <Multiselect v-if="field.type === 'dropdown'"
                           :class="parentProps.class"
                           :id="`additional_field_${field.name}`"
                           v-model="form.p2cConfig[field.name]"
                           :options="field.values"
                           :custom-label="(opt) => field.customLabel(opt)"
                           :multiple="false"
                           select-label="Select"
                           placeholder=""
              >
              </Multiselect>
            </FormInputWrapper>
          </div>
        </div>
      </div>

      <div class="requisites__container" v-if="rawFields.length > 0">
        <div class="requisites__block" v-for="field in rawFields">
          <div class="requisites__label requisites__label--start text-capitalize-first">
            {{ $t(`labels.raw_field.${field.name}`,{}, field.name) }}
          </div>
          <div class="requisites__content">
            <FormInputWrapper v-slot="parentProps" :field="`raw_field_${field.name}`" form="requisitesForm">

              <input :readonly="field.readonly ?? false" v-if="field.type === 'input'" v-model="form.raw[field.name]" :class="parentProps.class" type="text" class="form-control" :id="`raw_field_${field.name}`">
              <textarea :readonly="field.readonly ?? false" rows="5" v-if="field.type === 'textarea'" v-model="form.raw[field.name]" :class="parentProps.class" type="text" class="form-control" :id="`raw_field_${field.name}`"></textarea>
              <DropzoneInput :options="{accept:['.jpg', '.png', '.jpeg'], multiple: false, maxFiles: 1}"  v-if="field.type === 'dropzone'" @change="field.dropzone?.onChange" :label="field.label"></DropzoneInput>
            </FormInputWrapper>
          </div>
        </div>
      </div>

      <div class="requisites__container">
        <div class="requisites__block">
          <div class="requisites__label requisites__label--start text-capitalize-first">{{ $t('labels.req_group') }}</div>
          <div class="requisites__content">
            <FormInputWrapper v-slot="parentProps" field="groupId" form="requisitesForm">
              <Multiselect id="group"
                           :class="parentProps.class"
                           v-model="form.groupId"
                           :options="store.getters['reqGroups/ids']"
                           :custom-label="(opt) => store.getters['reqGroups/get'](opt)?.name"
                           :multiple="false"
                           select-label="Select"
                           placeholder=""
              >
              </Multiselect>
            </FormInputWrapper>
          </div>
        </div>
        <div class="requisites__block">
          <div class="requisites__label requisites__label--start text-capitalize-first">{{ $t('labels.device') }}</div>
          <div class="requisites__content">
            <FormInputWrapper v-slot="parentProps" field="deviceId" form="requisitesForm">
            <Multiselect id="device"
                         :class="parentProps.class"
                         v-model="form.deviceId"
                         :options="store.getters['devices/ids']"
                         :custom-label="(opt) => store.getters['devices/get'](opt)?.name"
                         :multiple="false"
                         select-label="Select"
                         placeholder=""
            >
            </Multiselect>
          </FormInputWrapper>
          </div>
        </div>
      </div>

      <div class="requisites__container requisites__container--row">
        <div class="requisites__block requisites__block--50 align-items-start">
          <div class="requisites__label requisites__label--start text-capitalize-first">
            {{ $t("labels.min_pay_in_deal_sum") }}
            <i v-if="isLimitsBlocked && form.id" 
               class="fa fa-question-circle text-info ms-2" 
               :title="$t('labels.limits_blocked_by_plan')"
               style="cursor: help;"></i>
          </div>
          <div class="requisites__content">
            <FormInputWrapper v-slot="parentProps" field="minPayInDealSum" form="requisitesForm">
              <input v-model="form.minPayInDealSum"
                     v-maska
                     :readonly="!form.payInDealSumsEditable || isLimitsBlocked"
                     :class="[parentProps.class, { 'form-control--disabled': isLimitsBlocked, 'form-control--danger': form.id && isLimitsBlocked, 'form-control--success': form.id && !isLimitsBlocked }]"
                     v-b-tooltip.hover :title="isLimitsBlocked && form.id ? $t('labels.limits_blocked_by_plan') : null"
                     data-maska="9 99#"
                     data-maska-tokens="9:[0-9]:repeated"
                     data-maska-reversed
                     type="text" class="form-control " id="minPayInDealSum">
            </FormInputWrapper>
            <div v-if="reuseCapEvaluation.status !== 'ok'" class="small mt-1" :class="reuseCapEvaluation.status === 'blocked' ? 'reuse-cap--blocked' : 'reuse-cap--partial'">
              <div>{{ reuseCapEvaluation.status === 'blocked' ? $t('labels.reuse_cap_blocked') : $t('labels.reuse_cap_partial') }}</div>
              <div v-for="group in reuseCapEvaluation.blockedGroups" :key="`blocked-${group.groupId}`">
                {{ $t('labels.reuse_cap_group_blocked', {group: group.name ?? $t('labels.reuse_cap_hidden_group'), cap: group.looseCap ?? group.strictCap, currency: form.currency}) }}
              </div>
              <div v-for="group in reuseCapEvaluation.partialGroups" :key="`partial-${group.groupId}`">
                {{ $t('labels.reuse_cap_group_partial', {group: group.name ?? $t('labels.reuse_cap_hidden_group'), cap: group.strictCap, currency: form.currency}) }}
              </div>
            </div>
            <div v-if="store.getters.getAppData?.payInMultiplesEnabled">
              <label for="multiplesOfValue" class="text-capitalize-first">{{ $t('labels.multiples_of_value') }}</label>
              <FormInputWrapper v-slot="parentProps" field="multiplesOfValue" form="requisitesForm">
                <input v-model="form.multiplesOfValue"
                       v-maska
                       :class="parentProps.class"
                       data-maska="9 99#"
                       data-maska-tokens="9:[0-9]:repeated"
                       data-maska-reversed
                       type="text" class="form-control" id="multiplesOfValue">
              </FormInputWrapper>
            </div>
          </div>
        </div>

        <div class="requisites__block requisites__block--50 align-items-start">
          <div class="requisites__label requisites__label--start text-capitalize-first">{{ $t("labels.max_pay_in_deal_sum") }}</div>
          <div class="requisites__content">
            <FormInputWrapper v-slot="parentProps" field="maxPayInDealSum" form="requisitesForm">
              <input v-model="form.maxPayInDealSum"
                     v-maska
                     :readonly="!form.payInDealSumsEditable"
                     :class="parentProps.class"
                     data-maska="9 99#"
                     data-maska-tokens="9:[0-9]:repeated"
                     data-maska-reversed
                     type="text" class="form-control " id="maxPayInDealSum">
            </FormInputWrapper>
          </div>
        </div>

        <div class="requisites__block requisites__block--50">
          <div class="requisites__label requisites__label--start text-capitalize-first">{{ $t("labels.daily_sum") }}</div>
          <div class="requisites__content gap-2">
            <FormInputWrapper v-slot="parentProps" field="dayTradesSumLimit" form="requisitesForm">
              <input v-model="form.dayTradesSumLimit"
                     v-maska
                     :class="parentProps.class"
                     data-maska="9 99#"
                     data-maska-tokens="9:[0-9]:repeated"
                     data-maska-reversed
                     type="text" class="form-control " id="dayTradesSumLimit">
            </FormInputWrapper>
            <div v-if="form.id" class="requisites__current-count">
              {{ $t("labels.current") }}: {{ numberFormatter.formatNumber(form.dayTradesSum) }}
            </div>
          </div>
        </div>

        <div class="requisites__block requisites__block--50">
          <div class="requisites__label requisites__label--start text-capitalize-first">{{ $t("labels.monthly_sum") }}</div>
          <div class="requisites__content gap-2">
            <FormInputWrapper v-slot="parentProps" field="monthTradesSumLimit" form="requisitesForm">
              <input v-model="form.monthTradesSumLimit"
                     v-maska
                     :class="parentProps.class"
                     data-maska="9 99#"
                     data-maska-tokens="9:[0-9]:repeated"
                     data-maska-reversed
                     type="text" class="form-control " id="monthTradesSumLimit">
            </FormInputWrapper>
            <div v-if="form.id" class="requisites__current-count">
              {{ $t("labels.current") }}: {{ numberFormatter.formatNumber(form.monthTradesSum) }}
            </div>
          </div>
        </div>

        <div class="requisites__block requisites__block--50">
          <div class="requisites__label requisites__label--start text-capitalize-first">{{ $t("labels.daily_qty") }}</div>
          <div class="requisites__content gap-2">
            <FormInputWrapper v-slot="parentProps" field="dayTradesCountLimit" form="requisitesForm">
              <input v-model="form.dayTradesCountLimit"
                     v-maska
                     :class="parentProps.class"
                     data-maska="9 99#"
                     data-maska-tokens="9:[0-9]:repeated"
                     data-maska-reversed
                     type="text" required class="form-control " id="dayTradesCountLimit">
            </FormInputWrapper>
            <div v-if="form.id" class="requisites__current-count">
              {{ $t("labels.current") }}: {{ numberFormatter.formatNumber(form.dayTradesCount) }}
            </div>
          </div>
        </div>

        <div class="requisites__block requisites__block--50">
          <div class="requisites__label requisites__label--start text-capitalize-first">{{ $t("labels.monthly_qty") }}</div>
          <div class="requisites__content gap-2">
            <FormInputWrapper v-slot="parentProps" field="monthTradesCountLimit" form="requisitesForm">
              <input v-model="form.monthTradesCountLimit"
                     v-maska
                     :class="parentProps.class"
                     data-maska="9 99#"
                     data-maska-tokens="9:[0-9]:repeated"
                     data-maska-reversed
                     type="text" required class="form-control " id="monthTradesCountLimit">
            </FormInputWrapper>
            <div v-if="form.id" class="requisites__current-count">
              {{ $t("labels.current") }}: {{ numberFormatter.formatNumber(form.monthTradesCount) }}
            </div>
          </div>
        </div>

        <div v-if="store.getters.getAppData?.requisitesAllDealsCountLimitsEnabled" class="requisites__block requisites__block--50">
          <div class="requisites__label requisites__label--start text-capitalize-first">{{ $t("labels.daily_qty_all_deals") }}</div>
          <div class="requisites__content gap-2">
            <FormInputWrapper v-slot="parentProps" field="dayTradesAllCountLimit" form="requisitesForm">
              <input v-model="form.dayTradesAllCountLimit"
                     v-maska
                     :class="parentProps.class"
                     data-maska="9 99#"
                     data-maska-tokens="9:[0-9]:repeated"
                     data-maska-reversed
                     type="text" required class="form-control " id="dayTradesAllCountLimit">
            </FormInputWrapper>
            <div v-if="form.id" class="requisites__current-count">
              {{ $t("labels.current") }}: {{ numberFormatter.formatNumber(form.dayTradesAllCount) }}
            </div>
          </div>
        </div>

        <div v-if="store.getters.getAppData?.requisitesAllDealsCountLimitsEnabled" class="requisites__block requisites__block--50">
          <div class="requisites__label requisites__label--start text-capitalize-first">{{ $t("labels.monthly_qty_all_deals") }}</div>
          <div class="requisites__content gap-2">
            <FormInputWrapper v-slot="parentProps" field="monthTradesAllCountLimit" form="requisitesForm">
              <input v-model="form.monthTradesAllCountLimit"
                     v-maska
                     :class="parentProps.class"
                     data-maska="9 99#"
                     data-maska-tokens="9:[0-9]:repeated"
                     data-maska-reversed
                     type="text" required class="form-control " id="monthTradesAllCountLimit">
            </FormInputWrapper>
            <div v-if="form.id" class="requisites__current-count">
              {{ $t("labels.current") }}: {{ numberFormatter.formatNumber(form.monthTradesAllCount) }}
            </div>
          </div>
        </div>

        <div v-if="form.id" class="requisites__block requisites__block--50--all justify-content-end">
          <LoaderButton :on-click="() => resetLimits('day')" class="btn btn-outline-primary btn-sm flex-0_5">
            <span class="text-capitalize-first">{{ $t('button.reset_day_limit') }}</span>
          </LoaderButton>
        </div>

        <div v-if="form.id" class="requisites__block requisites__block--50--all justify-content-end">
          <LoaderButton :on-click="() => resetLimits('month')" class="btn btn-outline-primary btn-sm flex-0_5">
            <span class="text-capitalize-first">{{ $t('button.reset_month_limit') }}</span>
          </LoaderButton>
        </div>

        <div v-if="monthLimitNextResetDate" class="requisites__block requisites__block--50--all justify-content-end requisites__block--right">
          <div class="requisites__current-count flex-0_5">
            {{ $t("labels.next_reset") }}: {{ monthLimitNextResetDate }}
          </div>
        </div>

        <template v-if="store.getters.getAppData?.requisitesTotalLimitEnabled">
          <div class="requisites__block requisites__block--50">
            <div class="requisites__label requisites__label--start text-capitalize-first">{{ $t("labels.total_sum") }}</div>
            <div class="requisites__content gap-2">
              <FormInputWrapper v-slot="parentProps" field="totalTradesSumLimit" form="requisitesForm">
                <input v-model="form.totalTradesSumLimit"
                       v-maska
                       :class="parentProps.class"
                       data-maska="9 99#"
                       data-maska-tokens="9:[0-9]:repeated"
                       data-maska-reversed
                       type="text" class="form-control " id="totalTradesSumLimit">
              </FormInputWrapper>
              <div v-if="form.id" class="requisites__current-count">
                {{ $t("labels.current") }}: {{ numberFormatter.formatNumber(form.totalTradesSum) }}
              </div>
            </div>
          </div>

          <div class="requisites__block requisites__block--50">
            <div class="requisites__label requisites__label--start text-capitalize-first">{{ $t("labels.total_qty") }}</div>
            <div class="requisites__content gap-2">
              <FormInputWrapper v-slot="parentProps" field="totalTradesCountLimit" form="requisitesForm">
                <input v-model="form.totalTradesCountLimit"
                       v-maska
                       :class="parentProps.class"
                       data-maska="9 99#"
                       data-maska-tokens="9:[0-9]:repeated"
                       data-maska-reversed
                       type="text" required class="form-control " id="totalTradesCountLimit">
              </FormInputWrapper>
              <div v-if="form.id" class="requisites__current-count">
                {{ $t("labels.current") }}: {{ numberFormatter.formatNumber(form.totalTradesCount) }}
              </div>
            </div>
          </div>

          <div class="requisites__block requisites__block--50 requisites__block--switcher">
            <div class="requisites__label text-capitalize-first">{{ $t('labels.manual_reset_enabled') }}</div>
            <div class="requisites__content requisites__content__switch">
              <label class="switch">
                <input type="checkbox" v-model="form.manualResetEnabled">
                <span class="slider"></span>
              </label>
            </div>
          </div>

          <div v-if="form.id && form.manualResetEnabled" class="requisites__block requisites__block--50--all justify-content-end">
            <LoaderButton :on-click="() => resetLimits('total')" class="btn btn-outline-primary btn-sm flex-0_5">
              <span class="text-capitalize-first">{{ $t('button.reset_total_limit') }}</span>
            </LoaderButton>
          </div>
        </template>

      </div>

      <div class="requisites__container requisites__container--row">
        <div class="requisites__block requisites__block--50"  v-if="form.maxReuseCountEnable">
          <div class="requisites__label requisites__label--start text-capitalize-first">{{ $t("labels.maxReuseCount") }}</div>
          <div class="requisites__content">
            <FormInputWrapper v-slot="parentProps" field="maxReuseCount" form="requisitesForm">
              <input v-model="form.maxReuseCount"
                     v-maska
                     :class="parentProps.class"
                     data-maska="9 99#"
                     data-maska-tokens="9:[0-9]:repeated"
                     data-maska-reversed
                     type="text" required class="form-control " id="maxReuseCount">
            </FormInputWrapper>
          </div>
        </div>

        <div class="requisites__block requisites__block--50"  v-if="form.maxReuseCountEnable">
          <div class="requisites__label requisites__label--start text-capitalize-first">{{ $t("labels.reuseDaysCount") }}</div>
          <div class="requisites__content">
            <FormInputWrapper v-slot="parentProps" field="reuseDaysCount" form="requisitesForm">
              <input v-model="form.reuseDaysCount"
                     v-maska
                     :class="parentProps.class"
                     data-maska="9 99#"
                     data-maska-tokens="9:[0-9]:repeated"
                     data-maska-reversed
                     type="text" required class="form-control " id="reuseDaysCount">
            </FormInputWrapper>
          </div>
        </div>

        <div class="requisites__block requisites__block--50"  v-if="form.maxReuseCountEnable">
          <div class="requisites__label requisites__label--start text-capitalize-first">{{ $t("labels.reusablePaymentsCountLimit") }}</div>
          <div class="requisites__content">
            <FormInputWrapper v-if="!store.getters.getAppData?.requisitesReusablePaymentsCountLimitEnabled" v-slot="parentProps" field="reusablePaymentsCountLimit" form="requisitesForm">
              <input v-model="form.reusablePaymentsCountLimit"
                     v-maska
                     :class="parentProps.class"
                     data-maska="9 99#"
                     data-maska-tokens="9:[0-9]:repeated"
                     data-maska-reversed
                     type="text" required class="form-control " id="reusablePaymentsCountLimit">
            </FormInputWrapper>
            <input v-else
                   :value="store.getters.getAppData?.requisitesReusablePaymentsCountLimit ?? 11"
                   disabled
                   type="text"
                   class="form-control form-control--disabled"
                   id="reusablePaymentsCountLimit">
          </div>
        </div>

        <div class="requisites__block requisites__block--100" v-if="!templateMode">
          <div class="requisites__content">
            <button type="button" @click="$emit('show-counterparties', form.id)" class="btn btn-outline-primary btn-sm text-capitalize-first">
              {{ $t('button.counterparties') }}
            </button>
          </div>
        </div>
      </div>

      <div class="requisites__container requisites__container--row">
        <div class="requisites__block requisites__block--50 requisites__block--switcher">
          <div class="requisites__label text-capitalize-first">{{ $t('labels.onlyInternalTransfer') }}</div>
          <div class="requisites__content requisites__content__switch">
            <label class="switch">
              <input type="checkbox" v-model="form.onlyInternalTransfer">
              <span class="slider"></span>
            </label>
          </div>
        </div>
      </div>

      <div class="requisites__container requisites__container--row">
        <div class="requisites__block requisites__block--50 requisites__block--switcher">
          <div class="requisites__label text-capitalize-first">{{ $t('labels.farmsSettings') }}</div>
          <div class="requisites__content requisites__content__switch">
            <label class="switch">
              <input type="checkbox" v-model="form.isFarmsSettingsEnabled">
              <span class="slider"></span>
            </label>
          </div>
        </div>

        <div class="requisites__block requisites__block--50 requisites__block--switcher" v-if="!templateMode && !form.id && store.getters.getAppData?.fraudexEnabled">
          <div class="requisites__label text-capitalize-first">{{ $t('labels.white_triangle') }}</div>
          <div class="requisites__content requisites__content__switch">
            <label class="switch">
              <input type="checkbox" v-model="form.isWhiteTriangle" @change="handleWhiteTriangleChange">
              <span class="slider"></span>
            </label>
          </div>
        </div>
      </div>

      <div class="requisites__container requisites__container--row" v-if="form.isFarmsSettingsEnabled">
        <div class="requisites__block requisites__block--50"  v-if="form.isFarmsSettingsEnabled">
          <div class="requisites__label requisites__label--start">{{ $t("labels.concurrent_trader_count") }}</div>
          <div class="requisites__content">
            <FormInputWrapper v-slot="parentProps" field="concurrentTradesCount" form="requisitesForm">
              <input v-model="form.concurrentTradesCount"
                     v-maska
                     :class="parentProps.class"
                     data-maska="9 99#"
                     data-maska-tokens="9:[0-9]:repeated"
                     data-maska-reversed
                     type="text" class="form-control " id="concurrentTradesCount">
            </FormInputWrapper>
          </div>
        </div>

        <div class="requisites__block requisites__block--50"  v-if="form.isFarmsSettingsEnabled">
          <div class="requisites__label requisites__label--start">{{ $t("labels.trades_timeout_minutes") }}</div>
          <div class="requisites__content">
            <FormInputWrapper v-slot="parentProps" field="tradesTimeoutMinutes" form="requisitesForm">
              <input v-model="form.tradesTimeoutMinutes"
                     v-maska
                     :class="parentProps.class"
                     data-maska="9 99#"
                     data-maska-tokens="9:[0-9]:repeated"
                     data-maska-reversed
                     type="text" class="form-control " id="tradesTimeoutMinutes">
            </FormInputWrapper>
          </div>
        </div>
      </div>

      <div v-if="!templateMode && form.method && blacklistMethods.includes(form.method)" class="requisites__container">
        <FormInputWrapper v-slot="parentProps" field="isAgreeBlacklistPaymentMethod" form="requisitesForm">
          <div class="" :class="parentProps.class" role="alert">
            <div class="">
              <input class="" v-model="form.isAgreeBlacklistPaymentMethod" type="checkbox" value="" id="isAgreeBlacklistPaymentMethod">
              <label class="" for="isAgreeBlacklistPaymentMethod">
                {{ $t('labels.agree_with_risk')}}
              </label>
            </div>
          </div>
        </FormInputWrapper>
      </div>

      <div class="requisites__controls">
        <button class="btn" type="button" @click.prevent="hide">
          <span class="text-capitalize-first">{{ $t('button.cancel') }}</span>
        </button>
        <LoaderButton :on-click="save" class="btn btn--accept">
          <span class="text-capitalize-first">{{ $t('button.save') }}</span>
        </LoaderButton>
      </div>
    </form>
  </Popup>
  <FraudexCheckPopup 
    v-if="store.getters.getAppData?.fraudexEnabled"
    :ref="(el) => fraudexCheckPopup = el"
    :fraudexCheck="fraudexCheckData || null"
    @continue="handleFraudexCheckContinue"
    @cancel="handleFraudexCheckCancel"
  />
</template>
<script lang="ts">
import {computed, defineComponent, nextTick, onMounted, ref, toRef, watch} from 'vue'
import {reactive, toRefs} from '@vue/reactivity';
import Popup from "@/apps/public/components/Popup.vue";
import {$t, helper} from "@/service/CommonHelper";
import LoaderButton from "@/apps/public/components/LoaderButton.vue";
import {api} from "@/service/APIClient";
import CopyButton from "@/apps/public/components/CopyButton.vue";
import {useNotification} from "@kyvg/vue3-notification";
import {useStore} from "vuex";
import FormInputWrapper from "@/components/FormInputWrapper.vue";
import RequisitesFormDTO, {AdditionalField, getAdditionalFields} from "@/models/form/RequisitesFormDTO";
import TraderRequisitesDTO from "@/models/TraderRequisitesDTO";
import Multiselect from "vue-multiselect";
import {PaymentOption} from "@/models/enum/PaymentOption";
import PayMethodIcon from "@/components/PayMethodIcon.vue";
import {PaymentMethod} from "@/models/enum/PaymentMethod";
import RequisitesUpdateRequestDTO from "@/models/request/RequisitesUpdateRequestDTO";
import DropzoneInput from "@/apps/public/components/DropzoneInput.vue";
import jsQR from "jsqr";
import {buildPixRawPayload, buildQrisRawPayload, buildVietQrRawPayload, clearPixRawFields, clearQrisRawFields, clearVietQrRawFields, detectVietQrInputMode, isPixRawComplete, isQrisRawComplete, isVietQrAccountNumberValid, isVietQrRawComplete, normalizeVietQrRaw, pixBackendErrorLabel, pixEmvFromRaw, qrisBackendErrorLabel, qrisEmvFromRaw, readFileAsDataUrl, readQrStringFromImageFile, VietQrInputMode} from "@/service/vietQrRawHelpers";
import {crossBorderAccountRequisites, crossBorderRawPayload, crossBorderSwift} from "@/service/crossBorderSwift";
import ValidationErrorDTO from "@/models/ValidationErrorDTO";
import {numberFormatter} from "@/service/NumberFormatter";
import FraudexCheckPopup from "@/apps/public/components/FraudexCheckPopup.vue";
import FraudexCheckResponseDTO from "@/models/FraudexCheckResponseDTO";
import {ReuseMinCapsDTO} from "@/models/ReuseMinCapsDTO";
import {evaluateReuseMinCaps, loadReuseMinCaps} from "@/apps/public/service/reuseMinCaps";
import RequisiteTemplateDTO from "@/models/RequisiteTemplateDTO";
import RequisiteTemplateRequestDTO from "@/models/request/RequisiteTemplateRequestDTO";
import {buildTemplateFields, findStaleTemplateFields, StaleTemplateField, TemplateAvailability, TemplateFieldFlags, templateToFormPatch} from "@/apps/public/service/requisiteTemplate";

const defaultCreateForm = {
  id: null,
  isActive: false,
  isWhiteTriangle: false,
  requisites: null,
  holderName: null,
  accountNumber: null,
  method: null,
  maxReuseCount: null,
  reuseDaysCount: 10,
  paymentOption: null,
  currency: null,
  crossBorderCurrency: null,
  dayTradesCountLimit: 0,
  monthTradesCountLimit: 0,
  dayTradesAllCountLimit: 0,
  monthTradesAllCountLimit: 0,
  dayTradesSumLimit: null,
  monthTradesSumLimit: null,
  totalTradesCountLimit: 0,
  totalTradesSumLimit: null,
  manualResetEnabled: false,
  deviceId: null,
  groupId: null,
  minPayInDealSum: null,
  maxPayInDealSum: null,
  multiplesOfValue: null,
  payInDealSumsEditable: true,
  isFarmsSettingsEnabled: false,
  onlyInternalTransfer: false,
  concurrentTradesCount: null,
  tradesTimeoutMinutes: null,
  reusablePaymentsCountLimit: null,
  dayTradesCount: undefined,
  monthTradesCount: undefined,
  maxReuseCountEnable: false,
  paymentSystem: null,
  isAgreeBlacklistPaymentMethod: null,
  p2cConfig: {},
  raw: {},
  vietQrIsStatic: false,
  qrisIsStatic: false,
  pixIsStatic: false,
} as RequisitesFormDTO

export default defineComponent({
  emits: ['updated', 'template-saved'],
  methods: {$t},
  components: {
    DropzoneInput,
    PayMethodIcon,
    FormInputWrapper,
    LoaderButton,
    CopyButton,
    Popup,
    Multiselect,
    FraudexCheckPopup
  },
  setup(props, {emit}) {
    const notification = useNotification()
    const store = useStore()
    const popup = ref<InstanceType<typeof Popup> | null>(null)
    const fraudexCheckPopup = ref<InstanceType<typeof FraudexCheckPopup> | null>(null)
    const state = reactive({
      form: {} as RequisitesFormDTO,
      blacklistMethods: [] as string[],
      isLimitsBlocked: false,
      fraudexCheckData: null as FraudexCheckResponseDTO | null,
      vietQrInputMode: 'auto' as VietQrInputMode,
      reuseMinCaps: null as ReuseMinCapsDTO | null,
      templateMode: false,
      templateId: null as number | null,
      templateName: '',
      templates: [] as RequisiteTemplateDTO[],
      selectedTemplate: null as RequisiteTemplateDTO | null,
      appliedTemplate: null as RequisiteTemplateDTO | null,
    });

    const templatesEnabled = computed<boolean>(() => !!store.getters.getAppData?.REQUISITES_TEMPLATES_ENABLED && !!store.getters.isTrader);

    const templateSelectVisible = computed<boolean>(() =>
      !state.templateMode && !state.form.id && templatesEnabled.value && state.templates.length > 0
    );

    const popupTitle = computed<string>(() => {
      if (state.templateMode) {
        return state.templateId
          ? $t('requisites.templates.edit_title')
          : $t('requisites.templates.create_title')
      }

      return state.form.id
        ? $t('labels.edit_requisites', {req: state.form.requisites || state.form.holderName || ('#' + state.form.id)})
        : $t('labels.create_requisites')
    });

    const reuseMinCapFeatureEnabled = computed<boolean>(() => !!store.getters.getAppData?.REQUISITES_REUSE_MIN_SUM_CAP_ENABLED);

    const reuseCapEvaluation = computed(() => {
      const maxReuseCount = Number.parseInt(`${state.form.maxReuseCount ?? ''}`.replace(/\s/g, ''), 10);
      if (!reuseMinCapFeatureEnabled.value || !(maxReuseCount > 0)) {
        return evaluateReuseMinCaps(null, null, null);
      }

      const rawMin = `${state.form.minPayInDealSum ?? ''}`.replace(/\s/g, '');
      const min = rawMin === '' ? null : Number.parseInt(rawMin, 10);

      return evaluateReuseMinCaps(state.reuseMinCaps, state.form.currency, Number.isNaN(min) ? null : min);
    });

    const fraudexCheckData = computed(() => state.fraudexCheckData);

    const monthLimitNextResetDate = computed(() => {
      const resetOn = state.form.monthLimitNextResetOn;
      const appData = store.getters.getAppData;
      if (!state.form.id || !resetOn || appData?.requisitesTotalLimitEnabled) {
        return null;
      }

      const monthLimits = [
        state.form.monthTradesSumLimit,
        state.form.monthTradesCountLimit,
        appData?.requisitesAllDealsCountLimitsEnabled ? state.form.monthTradesAllCountLimit : null,
      ];
      const hasMonthLimit = monthLimits.some((value) => Number(String(value ?? '').replace(/\s/g, '')) > 0);
      if (!hasMonthLimit) {
        return null;
      }

      const [year, month, day] = resetOn.split('-');

      return `${day}.${month}.${year}`;
    });
    let isHydratingForm = false

    const blankCreateForm = (): RequisitesFormDTO => ({
      ...defaultCreateForm,
      raw: {},
      p2cConfig: {},
      maxReuseCountEnable: store.getters.getUser.isRequisitesReuseEnable ?? true,
      ...(store.getters.getAppData?.requisitesReusablePaymentsCountLimitEnabled
        ? {reusablePaymentsCountLimit: store.getters.getAppData?.requisitesReusablePaymentsCountLimit ?? 11}
        : {}),
    })

    const show = (dto: TraderRequisitesDTO|null, blacklistMethods: string[], isLimitsBlocked: boolean = false) => {
      helper.clearErrors('requisitesForm')

      state.blacklistMethods = blacklistMethods
      state.isLimitsBlocked = isLimitsBlocked
      state.templateMode = false
      state.templateId = null
      state.templateName = ''
      state.selectedTemplate = null
      state.appliedTemplate = null
      state.templates = []
      isHydratingForm = true
      if (dto) {
        const raw = dto.paymentOption === PaymentOption.VIET_QR
          ? normalizeVietQrRaw(dto.raw && typeof dto.raw === 'object' ? {...dto.raw} : {}) as Record<string, unknown>
          : (dto.raw && typeof dto.raw === 'object' ? {...dto.raw} : {})
        if (dto.paymentOption === PaymentOption.IND_QR) {
          const emv = qrisEmvFromRaw(raw)
          if (emv) {
            raw.qrString = emv
          }
        }
        if (dto.paymentOption === PaymentOption.BR_QR) {
          const emv = pixEmvFromRaw(raw)
          if (emv) {
            raw.qrString = emv
          }
        }
        state.form = {
          ...blankCreateForm(),
          ...dto,
          raw,
          isWhiteTriangle: dto.isWhiteTriangle ?? false,
          vietQrIsStatic: dto.vietQrIsStatic ?? false,
          qrisIsStatic: dto.qrisIsStatic ?? false,
          pixIsStatic: dto.pixIsStatic ?? false,
          dayTradesCount: dto.dayTradesCount,
          monthTradesCount: dto.monthTradesCount,
          dayTradesAllCount: dto.dayTradesAllCount,
          monthTradesAllCount: dto.monthTradesAllCount,
          dayTradesSum: dto.dayTradesSum.amount,
          dayTradesSumLimit: Number.parseInt(dto.dayTradesSumLimit.amount).toString(),
          monthTradesSum: dto.monthTradesSum.amount,
          monthTradesSumLimit: Number.parseInt(dto.monthTradesSumLimit.amount).toString(),
          totalTradesCount: dto.totalTradesCount,
          totalTradesSum: dto.totalTradesSum.amount,
          totalTradesSumLimit: Number.parseInt(dto.totalTradesSumLimit.amount).toString(),
          manualResetEnabled: dto.manualResetEnabled ?? false,
          minPayInDealSum: dto.minPayInDealSum ? Number.parseInt(dto.minPayInDealSum!.amount).toString() : null,
          maxPayInDealSum: dto.maxPayInDealSum ? Number.parseInt(dto.maxPayInDealSum!.amount).toString() : null,
          multiplesOfValue: dto.multiplesOfValue != null ? String(dto.multiplesOfValue) : null,
          maxReuseCountEnable: store.getters.getUser.isRequisitesReuseEnable ?? true,
          ...(store.getters.getAppData?.requisitesReusablePaymentsCountLimitEnabled
            ? {reusablePaymentsCountLimit: store.getters.getAppData?.requisitesReusablePaymentsCountLimit ?? 11}
            : {}),
        } as RequisitesFormDTO
        state.vietQrInputMode = dto.paymentOption === PaymentOption.VIET_QR
          ? detectVietQrInputMode(raw)
          : 'auto'
      } else {
        state.form = blankCreateForm()
        state.vietQrInputMode = 'auto'
      }

      nextTick(() => {
        isHydratingForm = false
      })

      popup.value?.show()

      if (!dto && templatesEnabled.value) {
        loadTemplates()
      }
    }

    const loadTemplates = async () => {
      try {
        state.templates = await api.requisiteTemplatesAll()
      } catch (e) {
        state.templates = []
      }
    }

    const templateFlags = (): TemplateFieldFlags => {
      const appData = store.getters.getAppData

      return {
        allDealsCountLimits: !!appData?.requisitesAllDealsCountLimitsEnabled,
        totalLimits: !!appData?.requisitesTotalLimitEnabled,
        multiples: !!appData?.payInMultiplesEnabled,
        reuse: !!state.form.maxReuseCountEnable,
        reusablePaymentsCountLimit: !appData?.requisitesReusablePaymentsCountLimitEnabled,
      }
    }

    const showTemplate = (template: RequisiteTemplateDTO | null) => {
      helper.clearErrors('requisitesForm')

      state.blacklistMethods = []
      state.isLimitsBlocked = false
      state.templateMode = true
      state.templateId = template?.id ?? null
      state.templateName = template?.name ?? ''
      state.selectedTemplate = null
      state.appliedTemplate = null
      state.templates = []
      isHydratingForm = true
      state.form = blankCreateForm()
      state.vietQrInputMode = 'auto'
      if (template) {
        const patch = templateToFormPatch(template, templateFlags())
        Object.assign(state.form, patch.head, patch.body)
        if (patch.swift) {
          state.form.raw = {...(state.form.raw ?? {}), swift: patch.swift}
        }
      }

      nextTick(() => {
        isHydratingForm = false
      })

      popup.value?.show()
    }

    const applyTemplate = async (template: RequisiteTemplateDTO) => {
      helper.clearErrors('requisitesForm')
      state.appliedTemplate = template

      const patch = templateToFormPatch(template, templateFlags())
      Object.assign(state.form, patch.head)
      await nextTick()
      Object.assign(state.form, patch.body)
      if (patch.swift) {
        state.form.raw = {...(state.form.raw ?? {}), swift: patch.swift}
      }
    }

    const clearTemplate = () => {
      state.appliedTemplate = null
    }

    const isVietQr = computed(() => state.form.paymentOption === PaymentOption.VIET_QR)
    const isIndQr = computed(() => state.form.paymentOption === PaymentOption.IND_QR)
    const isBrQr = computed(() => state.form.paymentOption === PaymentOption.BR_QR)

    const isVietQrAutoMode = computed(() =>
      isVietQr.value && state.vietQrInputMode === 'auto'
    )

    const isHolderNameVisible = computed(() => {
      return !state.templateMode && state.form.paymentOption !== PaymentOption.P2C
    })

    const isAccountNumberVisible = computed(() => {
      if (state.templateMode || !state.form.paymentOption) {
        return false;
      }

      if (isIndQr.value || isBrQr.value) {
        return false;
      }

      if (isVietQrAutoMode.value) {
        return true;
      }

      if (state.form.paymentOption === PaymentOption.SBP_QR
        && [
          PaymentMethod.avangard_pos,
          PaymentMethod.multitransfer,
          PaymentMethod.whitebird,
          PaymentMethod.one_label,
          PaymentMethod.beeline,
          PaymentMethod.mts,
          PaymentMethod.mts_mobile,
          PaymentMethod.pay_to_phone_emu,
          PaymentMethod.qr_manager,
        ].includes(state.form.method as PaymentMethod)) {
        return false;
      }

      return ([PaymentOption.SBP, PaymentOption.TO_PHONE_NUMBER, PaymentOption.CLICK_UZ_QR, PaymentOption.SBP_QR, PaymentOption.TO_CARD] as PaymentOption[]).includes(state.form.paymentOption as PaymentOption)
    })

    const onVietQrImageChange = async (files: File[]) => {
      helper.clearErrors('requisitesForm')
      if (files.length !== 1) {
        return
      }
      const file = files[0]
      try {
        const qrString = await readQrStringFromImageFile(file)
        if (!qrString) {
          helper.setErrors('requisitesForm', [{
            code: "",
            field: "raw_field_qrImage",
            message: $t(isIndQr.value ? 'labels.qris_image_unreadable' : isBrQr.value ? 'labels.pix_image_unreadable' : 'labels.qr_upload_file_error'),
          } as ValidationErrorDTO])
          return
        }
        if (!state.form.raw) {
          state.form.raw = {}
        }
        state.form.raw.qrString = qrString
        state.form.raw.qrImage = await readFileAsDataUrl(file)
      } catch {
        helper.setErrors('requisitesForm', [{
          code: "",
          field: "raw_field_qrImage",
          message: $t(isIndQr.value ? 'labels.qris_image_unreadable' : isBrQr.value ? 'labels.pix_image_unreadable' : 'labels.qr_upload_file_error'),
        } as ValidationErrorDTO])
      }
    }

    const rawFields = computed<AdditionalField[]>(() => {
      if (state.templateMode) {
        return [] as AdditionalField[]
      }
      if (isIndQr.value || isBrQr.value || (isVietQr.value && state.vietQrInputMode === 'upload')) {
        return [
          {name: 'qrString', type: 'textarea'},
          {
            name: 'qrImage',
            type: 'dropzone',
            label: "labels.qr_upload_file",
            dropzone: {
              onChange: onVietQrImageChange,
            },
          },
        ] as AdditionalField[]
      }
      if (state.form.paymentOption === PaymentOption.TO_BANK_DETAILS) {

        let inputs = ['codeId', 'Name', 'PersonalAcc', 'BankName', 'BIC', 'CorrespAcc'];
        let fields = [
          {
            name: 'qrImage',
            type: 'dropzone',
            label: "labels.qr_upload_file",
            dropzone: {
              onChange:async (files: File[], rejected: any) => {
                helper.clearErrors('requisitesForm')
                if (files.length !== 1) {
                  return;
                }

                const file = files[0]
                const imageBitmap = await createImageBitmap(file)
                const canvas = document.createElement('canvas')
                canvas.width = imageBitmap.width
                canvas.height = imageBitmap.height
                const ctx = canvas.getContext('2d')!
                ctx.drawImage(imageBitmap, 0, 0)
                const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height)

                const qr = jsQR(imageData.data, canvas.width, canvas.height)

                if (!qr?.data) {
                  helper.setErrors('requisitesForm', [{
                    code: "",
                    field: "raw_field_qrImage",
                    message: $t('labels.qr_upload_file_error'),
                  } as ValidationErrorDTO])
                  return;
                }

                const data = qr.data.split('|');
                let index = 0;
                for (const item of data) {
                  const parts = item.split("=");
                  const name = parts[0] ?? null;
                  if (name.toLowerCase() === 'sum') {
                    continue;
                  }

                  const value = parts[1] ?? null;
                  if (index === 0) {
                    state.form.raw['codeId'] = name
                  } else {
                    state.form.raw[name] = value
                  }

                  switch (name.toLowerCase()) {
                    case 'personalacc':
                      state.form.requisites = value;
                      break;
                    case 'name':
                      state.form.holderName = value;
                      break;
                  }

                  index++;
                }

              }
            }
          }
        ] as AdditionalField[];

        for (const key of inputs) {
          fields.push({name: key, type: 'input', readonly: true})
        }

        for (const key in state.form.raw) {
          if (inputs.includes(key)) {
            continue;
          }

          fields.push({name: key, type: 'input', readonly: true})
        }

        return fields;
      }

      return [] as AdditionalField[]
    })

    const additionalFields = computed<AdditionalField[]>(() => {
      return state.templateMode ? [] : getAdditionalFields(state.form)
    })


    const requisitesMaskaPlaceholder = computed(() => {
      if (state.form.paymentOption === PaymentOption.SBP_QR) {
        switch (state.form.method as PaymentMethod) {
          case PaymentMethod.avangard_pos:
            return $t(`payment_options_requisites.login`, {}, '');
          case PaymentMethod.vasl:
          case PaymentMethod.beeline:
          case PaymentMethod.mts:
          case PaymentMethod.mts_mobile:
          case PaymentMethod.pay_to_phone_emu:
            return $t(`payment_options_requisites.phone_number`, {}, '');
          case PaymentMethod.multitransfer:
          case PaymentMethod.one_label:
            return '';
          case PaymentMethod.whitebird:
            return $t(`payment_options_requisites.login`, {}, '');
          case PaymentMethod.qr_manager:
            return $t(`payment_options_requisites.SBP_QR_qr_manager`, {}, '');
        }
      }

      const option = $t(`payment_options_requisites.${state.form.paymentOption}`, {}, '');

      return helper.trans(`payment_options_requisites.${state.form.paymentOption}_${state.form.method}`, {}, option);
    })


    const requisitesMaskaOptions = computed(() => {
      if (state.form.paymentOption === PaymentOption.VIET_QR || state.form.paymentOption === PaymentOption.IND_QR || state.form.paymentOption === PaymentOption.BR_QR) {
        return {pattern: null, tokens: null}
      }
      if (state.form.paymentOption === PaymentOption.CROSS_BORDER && crossBorderSwift(state.form.raw)) {
        return {
          pattern: '9',
          tokens: '9:[0-9]:repeated'
        }
      }
      if (!state.form.method || !state.form.requisites) {
        return {
          pattern: null,
          tokens: null
        }
      }

      if (state.form.paymentOption === PaymentOption.SBP_QR) {
        switch (state.form.method as PaymentMethod) {
          case PaymentMethod.avangard_pos:
          case PaymentMethod.whitebird:
          case PaymentMethod.one_label:
            return {pattern: null,tokens: null}
          case PaymentMethod.vasl:
          case PaymentMethod.beeline:
          case PaymentMethod.mts:
          case PaymentMethod.mts_mobile:
          case PaymentMethod.pay_to_phone_emu:
            return {pattern: helper.getPhonePattern(state.form.requisites), tokens: '9:[0-9]:repeated'};
          case PaymentMethod.multitransfer:
            return {pattern: null,tokens: null}
        }
      }

      if (state.form.paymentOption === PaymentOption.SBP_QR
        || state.form.paymentOption === PaymentOption.CLICK_UZ_QR
        || state.form.paymentOption === PaymentOption.P2C
        || state.form.paymentOption === PaymentOption.TIPS
        || state.form.paymentOption === PaymentOption.TO_BANK_DETAILS
        || state.form.paymentOption === PaymentOption.UPI
        || state.form.paymentOption === PaymentOption.QUASI_UPI
        || state.form.paymentOption === PaymentOption.IBAN
        || state.form.paymentOption === PaymentOption.PEN_QR
      ) {
        return {pattern: null,tokens: null}
      }

      if (state.form.paymentOption === PaymentOption.TO_ACCOUNT) {
        return {
          pattern: '9',
          tokens: '9:[0-9]:repeated'
        }
      }

      if (state.form.paymentOption === PaymentOption.CVU) {
        return {
          pattern: '######################',
          tokens: '9:[0-9]:repeated'
        }
      }

      if (state.form.paymentOption === PaymentOption.SBP || state.form.paymentOption === PaymentOption.TO_PHONE_NUMBER || state.form.requisites && state.form.requisites.startsWith('+')) {
        return {pattern: helper.getPhonePattern(state.form.requisites), tokens: '9:[0-9]:repeated'};
      }

      return {
        pattern: '#### #### #### ####',
        tokens: '9:[0-9]:repeated'
      }
    })

    const paymentOptionCurrency = computed((): string|null => {
      if (state.form.currency === null) {
        return null;
      }

      return ([PaymentOption.CROSS_BORDER, PaymentOption.MOBILE_TOP_UP] as PaymentOption[]).includes(state.form.paymentOption as PaymentOption) ? state.form.crossBorderCurrency : state.form.currency
    })

    const methodOptions = computed<string[]>(() => {
      const option = ![PaymentOption.CROSS_BORDER, PaymentOption.MOBILE_TOP_UP].includes(state.form.paymentOption as PaymentOption)
        ? state.form.paymentOption
        : (paymentOptionCurrency.value === 'RUB' ? state.form.paymentOption : null)

      return store.getters['currencyMethods/methods'](paymentOptionCurrency.value, option)
    })

    const hide = () => {
      popup.value?.hide()
    }

    const requisiteFieldLabel = computed(() => {
      if (state.form.paymentOption === PaymentOption.P2C) {
        switch (state.form.method) {
          case PaymentMethod.bkash_bdt:
            return helper.trans('labels.additional_field.username');
        }
      }

      return helper.trans('labels.requisites')
    })

    const parseHttpHeaders = (raw: string): {
      deviceid?: string;
      passwordhash?: string;
      hashcode?: string;
    } => {
      const result: Record<string, string | undefined> = {};

      const regex = /^(deviceid|passwordhash|hashcode):\s*(.+)$/gim;
      let match: RegExpExecArray | null;

      while ((match = regex.exec(raw)) !== null) {
        const key = match[1].toLowerCase();
        const value = match[2].trim();
        result[key] = value;
      }

      return {
        deviceid: result['deviceid'],
        passwordhash: result['passwordhash'],
        hashcode: result['hashcode'],
      };
    }

    watch(() => state.form.p2cConfig?.http_request, async (value, oldValue) => {
      if (value) {
        const data = parseHttpHeaders(value);
        state.form.p2cConfig['device_id'] = data.deviceid
        state.form.p2cConfig['hashcode'] = data.hashcode
        state.form.p2cConfig['passwordhash'] = data.passwordhash
      }
    })

    watch(() => state.form.paymentOption, (next, prev) => {
      if (isHydratingForm) {
        return
      }
      if (next === PaymentOption.VIET_QR && prev !== PaymentOption.VIET_QR) {
        if (!state.form.raw || typeof state.form.raw !== 'object') {
          state.form.raw = {}
        }
        state.vietQrInputMode = 'auto'
        state.form.vietQrIsStatic = false
      }
      if (next === PaymentOption.IND_QR && prev !== PaymentOption.IND_QR) {
        if (!state.form.raw || typeof state.form.raw !== 'object') {
          state.form.raw = {}
        }
        state.form.qrisIsStatic = false
        state.form.requisites = ''
        state.form.accountNumber = null
      }
      if (next === PaymentOption.BR_QR && prev !== PaymentOption.BR_QR) {
        if (!state.form.raw || typeof state.form.raw !== 'object') {
          state.form.raw = {}
        }
        state.form.pixIsStatic = false
        state.form.requisites = ''
        state.form.accountNumber = null
      }
      if (next === PaymentOption.MANUAL_SBP_QR) {
        state.form.requisites = ''
      }
      if (next === PaymentOption.CROSS_BORDER && (!state.form.raw || typeof state.form.raw !== 'object')) {
        state.form.raw = {}
      }
      if (prev === PaymentOption.CROSS_BORDER && next !== PaymentOption.CROSS_BORDER && state.form.raw && typeof state.form.raw === 'object') {
        delete state.form.raw.swift
      }
      if (prev === PaymentOption.VIET_QR && next !== PaymentOption.VIET_QR) {
        clearVietQrRawFields(state.form.raw)
        state.form.vietQrIsStatic = false
      }
      if (prev === PaymentOption.IND_QR && next !== PaymentOption.IND_QR) {
        clearQrisRawFields(state.form.raw)
        state.form.qrisIsStatic = false
      }
      if (prev === PaymentOption.BR_QR && next !== PaymentOption.BR_QR) {
        clearPixRawFields(state.form.raw)
        state.form.pixIsStatic = false
      }
    })

    watch(() => state.vietQrInputMode, (next, prev) => {
      if (isHydratingForm || !isVietQr.value || next === prev) {
        return
      }
      helper.clearErrors('requisitesForm')
      if (next === 'auto') {
        clearVietQrRawFields(state.form.raw)
      } else {
        state.form.accountNumber = null
        if (!state.form.raw || typeof state.form.raw !== 'object') {
          state.form.raw = {}
        }
      }
    })

    onMounted(() => {
      store.dispatch("currencyMethods/loadList");
      if (reuseMinCapFeatureEnabled.value) {
        loadReuseMinCaps()
          .then((caps) => {
            state.reuseMinCaps = caps;
          })
          .catch(() => {
            state.reuseMinCaps = null;
          });
      }
    })

    const handleWhiteTriangleChange = async () => {
      if (!state.form.isWhiteTriangle) {
        return;
      }

      if (!store.getters.getAppData?.fraudexEnabled) {
        state.form.isWhiteTriangle = false;
        return;
      }

      const fraudexPayload = isVietQr.value
        ? (state.vietQrInputMode === 'upload'
          ? (state.form.raw?.qrString?.trim() ?? '')
          : (state.form.accountNumber?.trim() ?? ''))
        : isIndQr.value || isBrQr.value
          ? (state.form.raw?.qrString?.trim() ?? '')
          : (state.form.requisites?.trim() ?? '')
      if (!fraudexPayload) {
        notification.notify({
          type: 'error',
          title: helper.trans('fraudex.requisite_required')
        });
        state.form.isWhiteTriangle = false;
        return;
      }

      try {
        const checkResult = await api.checkFraudexRequisite(fraudexPayload);
        state.fraudexCheckData = checkResult;
        fraudexCheckPopup.value?.show();
      } catch (e: any) {
        notification.notify({
          type: 'error',
          title: helper.trans('fraudex.check_error'),
          text: e.response?.data?.message || helper.trans('fraudex.check_failed')
        });
        state.form.isWhiteTriangle = false;
      }
    }

    const handleFraudexCheckContinue = () => {
      fraudexCheckPopup.value?.hide();
    }

    const handleFraudexCheckCancel = () => {
      fraudexCheckPopup.value?.hide();
      state.form.isWhiteTriangle = false;
      state.fraudexCheckData = null;
      hide();
    }

    const readMultiplesOfValue = (value: string | number | null | undefined): number | null => {
      const raw = `${value ?? ''}`.replace(/\s/g, '')
      if (!raw) {
        return null
      }
      const parsed = Number.parseInt(raw, 10)
      return parsed > 0 ? parsed : null
    }

    const notifyStaleTemplate = (fields: StaleTemplateField[]) => {
      const name = state.appliedTemplate?.name ?? ''
      const errors: ValidationErrorDTO[] = []
      for (const field of fields) {
        const message = helper.trans('requisites.templates.stale_field', {
          field: helper.trans(`requisites.templates.field.${field}`),
          name,
        })
        errors.push({code: 'INVALID_VALUE', field, message} as ValidationErrorDTO)
        notification.notify({
          type: 'error',
          title: helper.trans('requisites.templates.stale_title'),
          text: message,
        })
      }
      helper.setErrors('requisitesForm', errors)
    }

    const hasStaleTemplateFields = (): boolean => {
      if (!state.appliedTemplate) {
        return false
      }

      helper.clearErrors('requisitesForm')
      const availability: TemplateAvailability = {
        currencies: store.getters['currencyMethods/currencies'],
        paymentOptions: store.getters['currencyMethods/options'](state.form.currency),
        methods: methodOptions.value,
        paymentSystems: store.getters['currencyMethods/paymentSystems'](state.form.currency, state.form.paymentOption),
        crossBorderCurrencies: store.getters['currencyMethods/crossBorderCurrencies'],
        groupIds: store.getters['reqGroups/ids'],
        deviceIds: store.getters['devices/ids'],
      }
      const stale = findStaleTemplateFields(state.appliedTemplate, state.form, availability)
      if (stale.length === 0) {
        return false
      }

      notifyStaleTemplate(stale)

      return true
    }

    const saveTemplate = async (paymentSystems: string[]) => {
      helper.clearErrors('requisitesForm')
      const name = state.templateName.trim()
      if (!name) {
        helper.setErrors('requisitesForm', [{
          code: "INVALID_VALUE",
          field: "name",
          message: helper.trans('requisites.templates.name_required'),
        } as ValidationErrorDTO])
        return
      }

      const data = {
        name,
        ...buildTemplateFields(state.form, templateFlags(), paymentSystems),
      } as RequisiteTemplateRequestDTO

      try {
        if (state.templateId) {
          await api.requisiteTemplateUpdate(state.templateId, data)
        } else {
          await api.requisiteTemplateCreate(data)
        }
        notification.notify({title: helper.trans('requisites.templates.saved')})
        emit('template-saved')
        hide()
      } catch (e: any) {
        const errorData = e.response?.status === 400 ? e.response.data : null
        if (Array.isArray(errorData)) {
          helper.setErrors('requisitesForm', errorData.map((err: ValidationErrorDTO) =>
            err.field === 'swift' ? {...err, field: 'raw.swift'} : err
          ))
          return
        }

        helper.handleErrors('requisitesForm', e)
      }
    }

    const save = async () => {
      const form = state.form
      const maxMaxReuseCount = store.getters.getAppData?.requisitesMaxReuseCount ?? 15

      const paymentSystems = store.getters['currencyMethods/paymentSystems'](form.currency, form.paymentOption) as string[];

      const maxReuseCount = form.maxReuseCount ? Number.parseInt(form.maxReuseCount!.toString()!.replace(/\s/g, '')) : null;
      if (maxReuseCount !== null && (maxReuseCount < 1 || maxReuseCount > maxMaxReuseCount)) {
        helper.setErrors('requisitesForm', [{
          code: "INVALID_VALUE",
          field: "maxReuseCount",
          message: `${helper.trans('labels.maxReuseCount')}: ${helper.trans('server_errors.INVALID_VALUE')} (1-${maxMaxReuseCount})`,
        }]);
        return;
      }

      if (state.templateMode) {
        await saveTemplate(paymentSystems)
        return;
      }

      if (!form.id && hasStaleTemplateFields()) {
        return;
      }

      const isVietQrForm = form.paymentOption === PaymentOption.VIET_QR
      const isVietQrAuto = isVietQrForm && state.vietQrInputMode === 'auto'
      const isIndQrForm = form.paymentOption === PaymentOption.IND_QR
      const isBrQrForm = form.paymentOption === PaymentOption.BR_QR
      const holderName = form.holderName?.trim() ?? ''

      if (isVietQrForm) {
        const validationErrors: ValidationErrorDTO[] = []
        if (!holderName) {
          validationErrors.push({
            code: "INVALID_VALUE",
            field: "holderName",
            message: helper.trans('labels.viet_qr_holder_name_required'),
          } as ValidationErrorDTO)
        }
        if (isVietQrAuto) {
          if (!form.method?.trim()) {
            validationErrors.push({
              code: "INVALID_VALUE",
              field: "method",
              message: helper.trans('labels.viet_qr_method_required'),
            } as ValidationErrorDTO)
          }
          const accountNumber = form.accountNumber?.trim() ?? ''
          if (!isVietQrAccountNumberValid(accountNumber)) {
            validationErrors.push({
              code: "INVALID_VALUE",
              field: "accountNumber",
              message: helper.trans(accountNumber
                ? 'labels.viet_qr_account_number_digits_only'
                : 'labels.viet_qr_account_number_required'),
            } as ValidationErrorDTO)
          }
        } else if (!isVietQrRawComplete(form.raw as Record<string, unknown>)) {
          validationErrors.push({
            code: "INVALID_VALUE",
            field: "raw_field_qrString",
            message: helper.trans('labels.viet_qr_required'),
          } as ValidationErrorDTO)
        }
        if (validationErrors.length > 0) {
          helper.setErrors('requisitesForm', validationErrors)
          return
        }
      }

      if (isIndQrForm && !isQrisRawComplete(form.raw as Record<string, unknown>)) {
        helper.setErrors('requisitesForm', [{
          code: "INVALID_VALUE",
          field: "raw_field_qrImage",
          message: helper.trans('labels.qris_required'),
        } as ValidationErrorDTO])
        return
      }

      if (isBrQrForm && !isPixRawComplete(form.raw as Record<string, unknown>)) {
        helper.setErrors('requisitesForm', [{
          code: "INVALID_VALUE",
          field: "raw_field_qrImage",
          message: helper.trans('labels.pix_required'),
        } as ValidationErrorDTO])
        return
      }

      const isCrossBorder = form.paymentOption === PaymentOption.CROSS_BORDER
      let rawPayload = isVietQrForm
        ? (isVietQrAuto ? null : buildVietQrRawPayload(form.raw as Record<string, unknown>))
        : isIndQrForm
          ? buildQrisRawPayload(form.raw as Record<string, unknown>)
          : isBrQrForm
            ? buildPixRawPayload(form.raw as Record<string, unknown>)
            : form.raw
      let requisites = form.paymentOption === PaymentOption.MANUAL_SBP_QR || isIndQrForm || isBrQrForm ? '' : form.requisites
      if (isCrossBorder) {
        rawPayload = crossBorderRawPayload(form.raw)
        if (crossBorderSwift(form.raw)) {
          requisites = crossBorderAccountRequisites(requisites)
        }
      }

      const {vietQrIsStatic, qrisIsStatic, pixIsStatic, multiplesOfValue, ...formFields} = form

      const data = {
        ...formFields,
        raw: rawPayload,
        isWhiteTriangle: form.isWhiteTriangle ?? false,
        requisites,
        holderName: isVietQrForm || isIndQrForm || isBrQrForm ? holderName : form.holderName,
        accountNumber: form.paymentOption === PaymentOption.TO_ACCOUNT
          ? form.requisites
          : isVietQrAuto
            ? (form.accountNumber?.trim() ?? '')
            : (isVietQrForm || isIndQrForm || isBrQrForm ? null : form.accountNumber),
        ...(isVietQrForm ? { vietQrIsStatic: !!vietQrIsStatic } : {}),
        ...(isIndQrForm ? { qrisIsStatic: !!qrisIsStatic } : {}),
        ...(isBrQrForm ? { pixIsStatic: pixIsStatic === true } : {}),
        paymentSystem: paymentSystems.includes(form.paymentSystem ?? '') ? form.paymentSystem : null,
        dayTradesCountLimit: form.dayTradesCountLimit ? Number.parseInt(form.dayTradesCountLimit!.toString()!.replace(/\s/g, '')) : 0,
        monthTradesCountLimit: form.monthTradesCountLimit ? Number.parseInt(form.monthTradesCountLimit!.toString()!.replace(/\s/g, '')) : 0,
        dayTradesAllCountLimit: form.dayTradesAllCountLimit ? Number.parseInt(form.dayTradesAllCountLimit!.toString()!.replace(/\s/g, '')) : 0,
        monthTradesAllCountLimit: form.monthTradesAllCountLimit ? Number.parseInt(form.monthTradesAllCountLimit!.toString()!.replace(/\s/g, '')) : 0,
        monthTradesSumLimit: form.monthTradesSumLimit ? Number.parseInt(form.monthTradesSumLimit!.replace(/\s/g, '')) : null,
        dayTradesSumLimit: form.dayTradesSumLimit ? Number.parseInt(form.dayTradesSumLimit!.replace(/\s/g, '')) : null,
        totalTradesCountLimit: form.totalTradesCountLimit ? Number.parseInt(form.totalTradesCountLimit!.toString()!.replace(/\s/g, '')) : 0,
        totalTradesSumLimit: form.totalTradesSumLimit ? Number.parseInt(form.totalTradesSumLimit!.replace(/\s/g, '')) : null,
        minPayInDealSum: form.minPayInDealSum ? Number.parseInt(form.minPayInDealSum!.replace(/\s/g, '')) : null,
        maxPayInDealSum: form.maxPayInDealSum ? Number.parseInt(form.maxPayInDealSum!.replace(/\s/g, '')) : null,
        ...(store.getters.getAppData?.payInMultiplesEnabled ? {multiplesOfValue: readMultiplesOfValue(multiplesOfValue)} : {}),
        concurrentTradesCount: form.concurrentTradesCount ? Number.parseInt(form.concurrentTradesCount!.toString()!.replace(/\s/g, '')) : null,
        tradesTimeoutMinutes: form.tradesTimeoutMinutes ? Number.parseInt(form.tradesTimeoutMinutes!.toString()!.replace(/\s/g, '')) : null,
        maxReuseCount,
        reuseDaysCount: form.reuseDaysCount ? Number.parseInt(form.reuseDaysCount!.toString()!.replace(/\s/g, '')) : 0,
        ...(store.getters.getAppData?.requisitesReusablePaymentsCountLimitEnabled
          ? {reusablePaymentsCountLimit: store.getters.getAppData?.requisitesReusablePaymentsCountLimit ?? 11}
          : {}),
      } as RequisitesUpdateRequestDTO;

      let promise;
      if (form.id) {
        promise = api.updateRequisites(form.id, data)
          .then((resp) => {
            notification.notify({title: helper.trans('requisites.notice.updated')});
            return resp;
          })
      } else {
        promise = api.createRequisites(data)
          .then((resp) => {
            notification.notify({title: helper.trans('requisites.notice.created')});
            return resp;
          })
      }

      try {
        const resp = await promise;
        emit('updated', resp);
        hide();
      } catch (e: any) {
        if (e.response && e.response.status === 400 && e.response.data) {
          const errorData = e.response.data;

          if (Array.isArray(errorData) && errorData.length > 0) {
            const methodDisabledError = errorData.find((err: any) => err.field === 'method' && err.message === 'Payment method disabled');
            if (methodDisabledError) {
              if (state.appliedTemplate && state.appliedTemplate.method === form.method) {
                notifyStaleTemplate(['method']);
              } else {
                helper.setErrors('requisitesForm', [{
                  code: 'INVALID_VALUE',
                  field: 'method',
                  message: helper.trans('requisites.templates.method_disabled'),
                } as ValidationErrorDTO]);
              }
              return;
            }
            const manualEcomError = errorData.find(
              (err: any) =>
                (err.message && err.message.includes('Trader can have only one MANUAL_ECOM requisite')) ||
                err.field === 'paymentOption'
            );
            if (manualEcomError) {
              helper.setErrors('requisitesForm', [{
                code: 'ONLY_ONE_REQUISITE_OF_THIS_TYPE',
                field: 'paymentOption',
                message: helper.trans('server_errors.ONLY_ONE_REQUISITE_OF_THIS_TYPE')
              }]);
              return;
            }
            const error = errorData[0];
            if (error.message && error.message.includes('Min pay-in deal sum cannot be greater than trader limit')) {
              const traderLimitError = {
                code: 'MIN_PAY_IN_DEAL_SUM_EXCEEDS_TRADER_LIMIT',
                field: 'minPayInDealSum',
                message: error.message
              };
              helper.setErrors('requisitesForm', [traderLimitError]);
              return;
            }
            const qrisLabel = qrisBackendErrorLabel(error.message)
            if (qrisLabel) {
              helper.setErrors('requisitesForm', [{
                code: 'INVALID_VALUE',
                field: 'raw_field_qrImage',
                message: helper.trans(qrisLabel),
              } as ValidationErrorDTO]);
              return;
            }
            const pixLabel = pixBackendErrorLabel(error.message)
            if (pixLabel) {
              helper.setErrors('requisitesForm', [{
                code: 'INVALID_VALUE',
                field: 'raw_field_qrImage',
                message: helper.trans(pixLabel),
              } as ValidationErrorDTO]);
              return;
            }
          }
        }
        
        helper.handleErrors('requisitesForm', e);
      }
    }

    const resetLimits = async (type: 'day' | 'month' | 'total') => {
      if (!state.form.id) {
        return;
      }

      try {
        const updated = await api.resetRequisitesLimits(state.form.id, type);

        if (type === 'day') {
          state.form.dayTradesCount = updated.dayTradesCount;
          state.form.dayTradesSum = updated.dayTradesSum.amount;
        } else if (type === 'month') {
          state.form.monthTradesCount = updated.monthTradesCount;
          state.form.monthTradesSum = updated.monthTradesSum.amount;
        } else {
          state.form.totalTradesCount = updated.totalTradesCount;
          state.form.totalTradesSum = updated.totalTradesSum.amount;
        }

        notification.notify({
          title: helper.trans('requisites.notice.updated')
        });
        
        emit('updated');
      } catch (e: any) {
        helper.handleErrors('requisitesForm', e);
      } finally {
      }
    }

    return {
      ...toRefs(state),
      reuseCapEvaluation,
      popup,
      fraudexCheckPopup,
      requisiteFieldLabel,
      store,
      show,
      showTemplate,
      applyTemplate,
      clearTemplate,
      popupTitle,
      templateSelectVisible,
      methodOptions,
      hide,
      paymentOptionCurrency,
      additionalFields,
      rawFields,
      isHolderNameVisible,
      isAccountNumberVisible,
      isVietQr,
      isIndQr,
      isBrQr,
      isVietQrAutoMode,
      vietQrInputMode: toRef(state, 'vietQrInputMode'),
      requisitesMaskaPlaceholder,
      requisitesMaskaOptions,
      helper,
      save,
      resetLimits,
      monthLimitNextResetDate,
      numberFormatter,
      PaymentOption,
      isLimitsBlocked: toRef(state, 'isLimitsBlocked'),
      fraudexCheckData,
      handleWhiteTriangleChange,
      handleFraudexCheckContinue,
      handleFraudexCheckCancel,
      PaymentMethod
    }
  },
  async beforeMount() {
  }
})
</script>

<style scoped>
.form-control--disabled {
  background-color: #f8f9fa !important;
  color: #6c757d !important;
  cursor: not-allowed !important;
  opacity: 0.7;
}
.form-control--danger {
  border-color: #dc3545 !important;
  box-shadow: 0 0 0 2px rgba(220, 53, 69, 0.15);
}
.form-control--success {
  border-color: #198754 !important;
  box-shadow: 0 0 0 2px rgba(25, 135, 84, 0.15);
}
.requisites__current-value {
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.requisites__current-count {
  font-size: 11px;
  color: #6c757d;
  margin-top: 2px;
}

.requisites__block--right {
  margin-left: auto;
}
</style>
